import {
  FETCH_EXCHANGE_LIST_SUCCESS,
  FETCH_EXCHANGE_LOADER,
  SHOW_DASHBOARD_MESSAGE,
  HIDE_DASHBOARD_MESSAGE,
  SHOW_QUOTE_LOADER,
  FETCH_QUOTE_SUCCESS,
  SHOW_PATIENTS_LIST_TODAY_LOADER,
  FETCH_PATIENTS_LIST_TODAY_SUCCESS
} from 'constants/ActionTypes';

const INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  isErrorMessage: false,
  exchangeList: [],
  exchangeListLoader: false,
  qod: {},
  qodLoader: false,
  patientsTodayList: [],
  patientsTodayListLoader: false,
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_EXCHANGE_LIST_SUCCESS: {
      return {
        ...state,
        exchangeListLoader: true,
        exchangeList: action.payload
      }
    }
    case FETCH_EXCHANGE_LOADER: {
      return {
        ...state,
        exchangeListLoader: false,
      }
    }
    case SHOW_DASHBOARD_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload.message,
        isErrorMessage: action.payload.messageStatus,
        showMessage: true
      }
    }
    case HIDE_DASHBOARD_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        isErrorMessage: false,
        showMessage: false,
      }
    }
    case SHOW_QUOTE_LOADER: {
      return {
        ...state,
        qodLoader: false,
      }
    }
    case FETCH_QUOTE_SUCCESS: {
      return {
        ...state,
        qodLoader: true,
        qod: action.payload
      }
    }
    case SHOW_PATIENTS_LIST_TODAY_LOADER: {
      return {
        ...state,
        patientsTodayListLoader: false,
      }
    }
    case FETCH_PATIENTS_LIST_TODAY_SUCCESS: {
      return {
        ...state,
        patientsTodayListLoader: true,
        patientsTodayList: action.payload
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/Dashboard.js